module.exports = __webpack_public_path__ + "static/media/IMG_1810.25a19f83.jpg";